import { SITUACAO_VOTO } from './SituacaoVoto';

/**
 * @classdesc Agrega as regras semânticas relacionadas ao quórum do processo.
 * @readonly
 */
export default class QuorumBusiness {
    static isObedeceQuorumComposicao(registro, quorum) {
        let totalMagistrados = 0;
        for (let comp of registro?.composicao ? registro.composicao : []) {
            if (!this.isImpedido(registro, comp.magistrado.sigla) && !this.isAusente(comp.magistrado)) {
                totalMagistrados++;
            }
        }
        return totalMagistrados >= (quorum || 99);
    }

    static isAusente(magistrado) {
        return magistrado.ausente === true;
    }

    static isImpedido(registro, sigla) {
        return (
            registro.impedimentos &&
            registro.impedimentos.findIndex((impedimento) => impedimento.magistrado.sigla === sigla) !== -1
        );
    }

    static existeParticipanteComVotoDiferenteDeConfirmado(registro) {
        return (
            !registro.votos ||
            registro.votos.findIndex((voto) => voto.situacaoVoto !== SITUACAO_VOTO.CONFIRMADO.id) !== -1
        );
    }
}
